'use client';

import React from 'react';
import { ShieldCheck, Clock, Tablet } from 'lucide-react';

export default function QCReviewHeader() {
  const now = new Date();
  const dateStr = now?.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  const timeStr = now?.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });

  return (
    <header className="flex items-center justify-between px-5 py-4 border-b border-border bg-card flex-shrink-0">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-primary/15 flex items-center justify-center">
          <ShieldCheck size={22} className="text-primary" />
        </div>
        <div>
          <h1 className="text-base font-bold text-foreground tracking-tight">QC Review — Pending Items</h1>
          <p className="text-2xs text-muted-foreground">Approve or reject incoming inventory items</p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-muted/50">
          <Tablet size={13} className="text-muted-foreground" />
          <span className="text-xs text-muted-foreground">Tablet View</span>
        </div>
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <Clock size={13} />
          <span>{dateStr} · {timeStr}</span>
        </div>
      </div>
    </header>
  );
}
